import React, { useState } from "react"
import { Container, Row, Col } from 'react-bootstrap';
import Slider from "react-slick";
import ScrollAnimation from 'react-animate-on-scroll';
import ReactMarkdown from "react-markdown"
// Style
import './CustomersAdvocates.scss';
import { useStaticQuery, graphql } from "gatsby";
import GetURL from '@Components/common/site/get-url';
import getVideoId from 'get-video-id';
import YouTube from '@u-wave/react-youtube';
import ImageRenderer from "../../ImageRenderer/ImageRenderer"
import VideoModal from '@Components/Play/VideoModal';
const CustomersAdvocates = (props) => {
  const data = useStaticQuery(graphql`
  query {
    glstrapi {
          videoTestimonials(publicationState: LIVE, limit: 10, where: {Category:"Clients"}) {
            id
            imagetransforms
            Name
            Destination
            Video_Url
            Category
            ggfx_results {
                transforms
                src_url
                src_cftle
            }
            Photo {
              alternativeText
              url
            }
          }
        }
      }
    `);
  const [videoId, setVideoId] = useState('');
  const [showVideo, setShowVideo] = useState(false);
  const [videoindex, setVideoindex] = useState(null);
  const playVideo = (id, Embed_Video_URL) => {
    var videoid = getVideoId(Embed_Video_URL);
    setShowVideo(true)
    setVideoindex(id)
    setVideoId(videoid.id)
  }
  const closePlay = () => {
    setShowVideo(false)
    setVideoId('')
    setVideoindex(null)
  }
  const trackerVideo = (event) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'Video Play Btn',
      'formType': event,
      'formId': 'Video Play',
      'formName': 'Video',
      'formLabel': 'Video'
    });
  }
  const settings = {
    dots: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,

    responsive: [
      {
        breakpoint: 991,
        settings: {
          dots: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px',
        }
      },
      {
        breakpoint: 767,
        settings: {
          dots: true,
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
          centerPadding: '0px',
        }
      }
    ]
  };

  return (

    <div className="customers-advocates">
      <Container>
        {props.Title || props.Content &&
          <Row>
            <Col xs>
              <div className="customers-list">
                <div className="customers-content">
                  <h2>{props.Title}</h2>
                  <div className="rich-text-editer-block">
                    <ReactMarkdown source={props.Content} allowDangerousHtml />
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        }
        <div className="customers-slider slick-pagination">
          {props.View_More != null &&
            <div className="view-more-wrap">
              <GetURL isLinkArrow="true" label={props.View_More.CTA_1_Label} alias={props.View_More.CTA_1_URL.Alias} class={'link-text'} />
            </div>
          }

          <div className="d-flex25 customers-slide-wrap">
            <Slider {...settings}>
              {data.glstrapi.videoTestimonials.map((node, index) => {
                let processedImages = JSON.stringify({});
                if (node?.imagetransforms?.Image_Transforms) {
                  processedImages = node.imagetransforms.Image_Transforms;
                }
                return (

                  <div className="customer-col">
                    <div className="customer-img">
                      <ImageRenderer ImageSrc={node?.Photo} altText={node?.Photo?.alternativeText + ' - Bentley Hurst'} ggfx_results={node.ggfx_results} strapi_id={node.id} imagename='video-testimonial.Image.tail' />
                      <VideoModal video_url={node.Video_Url} icon={'light'} />
                    </div>
                    <div className="customers-info">
                      <h3>{node.Name}</h3>
                      <span className="destination">{node.Destination}</span>
                    </div>
                  </div>
                )
              })
              }
            </Slider>
          </div>
        </div>
      </Container>
    </div>
  )
}



export default CustomersAdvocates

